import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/workflows/user-workflows/{userWorkflowId}/comments']['GET'];
type Input = THIS_API['params'] & THIS_API['query'];
type Output = THIS_API['response'];

const getWorkflowConversationMessages = async ({
  contextId,
  page,
  perPage,
  userWorkflowId,
}: Input): Promise<Output> => {
  const response = await noodleApiClient.get(`/workflows/user-workflows/${userWorkflowId}/comments`, {
    params: { contextId, page, perPage },
  });
  return response.data;
};

export default getWorkflowConversationMessages;
